import { useContext } from "react";

import MealItemForm from "./MealItemForm";
import classes from "./MealItem.module.css";
import CartContext from "../../../store/cart-context";

const MealItem = (props) => {
  const cartCtx = useContext(CartContext);

  // console.log(props);
  // let priceValue;
  // cartCtx.items.forEach((meal) => {
  //   priceValue = meal.price.toFixed(2);
  // });

  // console.log(priceValue);
  // const price = `$${props.price.toFixed(2)}`;
  // console.log(props.price.trim());
  // console.log(cartCtx.items);

  const addToCartHandler = (amount) => {
    cartCtx.addItem({
      id: props.id,
      name: props.name,
      amount: amount,
      price: props.price,
    });
  };

  return (
    <li className={classes.meal}>
      <div>
        <h3>{props.name}</h3>
        <div className={classes.description}>{props.description}</div>
        {/* <div className={classes.price}>{priceValue}</div> */}
        <div className={classes.price}>{props.price}</div>
      </div>
      <div>
        <MealItemForm onAddToCart={addToCartHandler} />
      </div>
    </li>
  );
};

export default MealItem;
